import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

import { Flex, Loading } from 'components';
import { useSchool } from 'features/school';
import { AccountApiResponse, useAccount } from 'features/account';
import { createUrl, request } from 'app/utils';
import { AxiosResponse } from 'axios';
import { useContents } from 'features/contents';
import { useAuth } from 'features/auth';
import { useParams } from 'react-router-dom';

const ZoomWrapper = styled(Flex)`
  flex-direction: column;

  iframe {
    flex: 1;
    border: 0;
  }
`;

const ContentZoomView = () => {
  const [loading, setLoading] = useState(true);

  const { productSlug, productClassUuid } = useParams();

  const { fullName } = useAuth();
  const { schoolAlias, apiGatewayUrl, defaultAppUrl } = useSchool();
  const { account, setAccount } = useAccount();
  const { contentDetails } = useContents();

  var meetingNumber = contentDetails?.video?.externalVideoProviderIdOrUrl.split(' ').join('');

  const getAccount = useCallback(() => {
    setLoading(true);

    request({
      url: `/api/v1/School/MyAccount`,
      method: 'get',
      baseURL: apiGatewayUrl,
    })
      .then((response: AxiosResponse<AccountApiResponse>) => {
        setAccount(response.data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    getAccount();
  }, []);

  const productClassDetails = createUrl('productClassDetails', [productSlug, productClassUuid]);

  if (loading) return <Loading label="Por favor, aguarde." />;

  let zoomUrl = 'https://zoom.melver.com.br';
  // zoomUrl = 'http://localhost:4000';

  return (
    <ZoomWrapper bg="dark_350">
      <iframe
        title="zoom"
        allow="camera; microphone"
        src={`${zoomUrl}/player?schoolAlias=${schoolAlias}&name=${fullName}&email=${account?.accountLogin}&meetingNumber=${meetingNumber}&schooolUrl=${defaultAppUrl}&leaveUri=${productClassDetails}`}
      />

      {/* <iframe title="zoom" allow="camera; microphone" src={`${zoomUrl}/player/ended?leaveUrl=111`} /> */}
    </ZoomWrapper>
  );
};

export default ContentZoomView;
